// initial state for user auth and details
const USER_INIT = {};

export default USER_INIT;
